import api from "./api";
// 门店端首页详情
export const fetchIndexDetail = params => {
  return api("get", `/v1/management/store/index/indexDetail`, params);
};

// 新增问卷调查
export const putAddQuestion = params => {
  return api("put", `/v1/management/store/questionnaire/add`, params);
};

// 获取最新问卷
export const findLatest = params => {
  return api("get", `/v1/management/store/questionnaire/findLatest`, params);
};

// 问卷管理列表
export const fetchQuestionList = assessmentDate => {
  return api("get", `/v1/management/store/questionnaire/list/${assessmentDate}`);
};

// 问卷详情
export const fetchQuestionDetail = storePhysicalTestQuestionnaireId => {
  return api("get", `/v1/management/store/questionnaire/details/${storePhysicalTestQuestionnaireId}`);
};

// 重新体侧当前动作
export const reBodyTest = instanceId => {
  return api("post", `/adam/assessmentInStore/retry/${instanceId}`);
};

// 终止体测
export const stopBodyTest = instanceId => {
  return api("post", `/adam/assessmentInStore/stop/${instanceId}`);
};